module.exports = __webpack_public_path__ + "rainbow_six_slide_ru_desktop.webp";